import { Route, Routes, useLocation } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollToTop from "./components/ScrollToTop";
import PreLoader from "./components/PreLoader";
import LandingPage from "./pages/Landing/LandingPage";
import AboutPage from "./pages/About/AboutPage";
// import ServicePage from "./pages/Service/ServicePage";
import ContactPage from "./pages/Contact/ContactPage";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import BlockchainDevelopment from "./components/BlockchainDevelopment/BlockchainDevelopment";
import BlockchainConsulting from "./components/BlockchainConsulting/BlockchainConsulting";
import EthereumBlockchain from "./components/EthereumBlockchain/EthereumBlockchain";
import DappDevelopment from "./components/DappDevelopment/DappDevelopment";
// import EnterpriseBlockchain from "./components/EnterpriseBlockchain/EnterpriseBlockchain";
import SmartDevelopment from "./components/SmartDevelopment/SmartDevelopment";
import SmartAudit from "./components/SmartAudit/SmartAudit";
import SolidityDevelopment from "./components/SolidityDevelopment/SolidityDevelopment";
import CryptoDevelopment from "./components/CryptoDevelopment/CryptoDevelopment";
import CryptoWallet from "./components/CryptoWallet/CryptoWallet";
import CryptoExchange from "./components/CryptoExchange/CryptoExchange";
import Web3dappDevelopment from "./components/Web3dappDevelopment/Web3dappDevelopment";
import Web3gameDevelopment from "./components/Web3gameDevelopment/Web3gameDevelopment";
import Web3Consulting from "./components/Web3Consulting/Web3Consulting";
import MetaserveDevelopment from "./components/MetaverseDevelopment/MetaverseDevelopment";
import MetaversegameDevelopment from "./components/MetaversegameDevelopment/MetaversegameDevelopment";
import NFTMarketplace from "./components/NFTMarketplace/NFTMarketplace";
// import NFTTokenDevelopment from "./components/NFTTokenDevelopment/NFTTokenDevelopment";
import WhitelabelNft from "./components/WhitelabelNft/WhitelabelNft";
import P2EgameDevelopment from "./components/P2EgameDevelopment/P2EgameDevelopment";
import WebApplication from "./components/WebApplication/WebApplication";
import SoftwareDevelopment from "./components/SoftwareDevelopment/SoftwareDevelopment";
import MobileApplication from "./components/MobileApplication/MobileApplication";
import Logistics from "./components/Logistics/Logistics";
import Finance from "./components/Finance/Finance";
import Insurance from "./components/Insurance/Insurance";
import Education from "./components/Education/Education";



const App = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    AOS.init({
      once: false,
      mirror: true,
      duration: 1000,
      offset: 100,
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    setFadeOut(false);

    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, 800);

    const hideTimer = setTimeout(() => {
      setLoading(false);
    }, 1400);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, [location.pathname]);

  return (
    <Fragment>
      <ScrollToTop />
      {loading && (
        <div
          className={`preloader-container ${fadeOut ? "fade-out" : ""}`}
        >
          <PreLoader />
        </div>
      )}
      <Header />
      {!loading && (
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          {/* <Route path="/service" element={<ServicePage />} /> */}
          <Route path="/service/blockchain-development" element={<BlockchainDevelopment />} />
          <Route path="/service/blockchain-consulting" element={<BlockchainConsulting />} />
          <Route path="/service/ethereum-blockchain-development" element={<EthereumBlockchain />} />
          <Route path="/service/dapp-development" element={<DappDevelopment />} />
          {/* <Route path="/service/enterprise-blockchain-development" element={<EnterpriseBlockchain />} /> */}
          <Route path="/service/smart-contract-development" element={<SmartDevelopment />} />
          <Route path="/service/smart-contract-audit" element={<SmartAudit />} />
          <Route path="/service/solidity-development" element={<SolidityDevelopment />} />
          <Route path="/service/cryptocurrency-development" element={<CryptoDevelopment />} />
          <Route path="/service/cryptowallet-development" element={<CryptoWallet />} />
          <Route path="/service/cryptoexchange-development" element={<CryptoExchange />} />
          <Route path="/service/web3-dapp-development" element={<Web3dappDevelopment />} />
          <Route path="/service/web3game-development" element={<Web3gameDevelopment />} />
          <Route path="/service/web3-consulting-service" element={<Web3Consulting />} />
          <Route path="/service/metaverse-development" element={<MetaserveDevelopment />} />
          <Route path="/service/metaverse-game-development" element={<MetaversegameDevelopment />} />
          <Route path="/service/nft-marketplace" element={<NFTMarketplace/>}/>
          {/* <Route path="/service/nft-token-development" element={<NFTTokenDevelopment/>}/> */}
          <Route path="/service/white-label-nft" element={<WhitelabelNft/>}/>
          <Route path="/service/playtoearn-game-development" element={<P2EgameDevelopment/>}/>
          <Route path="/service/web-application" element={<WebApplication/>}/>
          <Route path="/service/software-development" element={<SoftwareDevelopment/>}/>
          <Route path="/service/mobile-application" element={<MobileApplication/>}/>
          <Route path="/service/logistics" element={<Logistics/>}/>
          <Route path="/service/finance" element={<Finance/>}/>
          <Route path="/service/insurance" element={<Insurance/>}/>
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      )}
      <Footer/>
    </Fragment>
  );
};

export default App;
